module.exports = __webpack_public_path__ + "img/map.caeeab2f.png";